import { render, staticRenderFns } from "./printTipsCom.vue?vue&type=template&id=08068e7a&scoped=true"
import script from "./printTipsCom.vue?vue&type=script&lang=js"
export * from "./printTipsCom.vue?vue&type=script&lang=js"
import style0 from "./printTipsCom.vue?vue&type=style&index=0&id=08068e7a&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08068e7a",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/work/jenkins/workspace/pre环境/快递系统/快递前端/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('08068e7a')) {
      api.createRecord('08068e7a', component.options)
    } else {
      api.reload('08068e7a', component.options)
    }
    module.hot.accept("./printTipsCom.vue?vue&type=template&id=08068e7a&scoped=true", function () {
      api.rerender('08068e7a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/operatingPlatform/component/printTipsCom.vue"
export default component.exports